<template>
  <div class="cp-drawer" :class="drawerClasses">
    <b-icon
      class="cp-drawer-close has-text-primary"
      pack="fas"
      icon="times"
      size="is-medium"
      @click.native="$emit('toggle-drawer')"
    ></b-icon>
    <div class="cp-drawer-item-container">
      <div class="cp-drawer-page-link">
        <router-link
          :class="{
            'has-text-grey': true,
            'is-size-4': true,
            'cp-drawer-page-link-item': true,
            'cp-drawer-page-link-item--active': true,
          }"
          to="/"
          exact
          @click.native="$emit('toggle-drawer')"
          >{{ $t('navigation.home') }}</router-link
        >
        <router-link
          :class="{ 'is-size-4': true, 'has-text-grey': true, 'cp-drawer-page-link-item': true }"
          to="/products"
          @click.native="$emit('toggle-drawer')"
          >{{ $t('navigation.products') }}</router-link
        >
        <!-- <router-link
          :class="{ 'is-size-4': true, 'has-text-grey': true, 'cp-drawer-page-link-item': true }"
          to="/articles"
          @click.native="$emit('toggle-drawer')"
          >{{ $t('navigation.articles') }}</router-link
        > -->
        <router-link
          :class="{ 'is-size-4': true, 'has-text-grey': true, 'cp-drawer-page-link-item': true }"
          to="/about"
          @click.native="$emit('toggle-drawer')"
          >{{ $t('navigation.about') }}</router-link
        >
        <router-link
          :class="{ 'is-size-4': true, 'has-text-grey': true, 'cp-drawer-page-link-item': true }"
          to="/contact"
          @click.native="$emit('toggle-drawer')"
          >{{ $t('navigation.contact') }}</router-link
        >
      </div>

      <div class="cp-drawer-contract has-background-primary">
        <p class="cp-drawer-telephone">{{ $t('navigation.tel') }}: {{ contact.phone_number }}</p>
        <div>
          <a
            class="cp-navigation-icon has-text-white"
            :href="contact.facebook"
            target="_blank"
            rel="noopener noreferrer"
          >
            <b-icon pack="fab" icon="facebook-square" size="is-medium"></b-icon>
          </a>
          <a
            class="cp-navigation-icon has-text-white"
            :href="`http://line.me/ti/p/~${contact.line_id}`"
            target="_blank"
            rel="noopener noreferrer"
          >
            <b-icon pack="fab" icon="line" size="is-medium"></b-icon>
          </a>
          <a
            class="cp-navigation-icon has-text-white"
            :href="`mailto:${contact.email}`"
            target="_blank"
            rel="noopener noreferrer"
          >
            <b-icon
              class="cp-navigation-icon"
              pack="fas"
              icon="envelope-square"
              size="is-medium"
            ></b-icon>
          </a>
        </div>
        <span>
          <a class="has-text-white" @click="updateLocale('th_TH')">TH </a>
          |
          <a class="has-text-white" @click="updateLocale('en_US')"> EN</a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Drawer',
  props: {
    isDrawerOpen: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapState({
      contact: state => state.contact,
    }),
    drawerClasses() {
      return {
        'drawer-active': this.isDrawerOpen,
      };
    },
  },
  methods: {
    updateLocale(locale) {
      this.$store.commit('updateLocale', locale);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
$primaryFontColor: #444444;
$paddingLeft: 20px;

.cp-drawer {
  padding-top: $navigationHeaderHeight;
  position: fixed;
  top: 0px;
  background-color: #fff;
  max-width: 280px;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  left: -100%;
  z-index: 20;
  box-shadow: 7px 0px 25px -2px rgba(0, 0, 0, 0.1);
  transition: left 0.25s;
  z-index: 31;

  @media screen and (min-width: 769px) {
    display: none;
  }

  &.drawer-active {
    left: 0px;
  }
}

.cp-drawer-close {
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
}

.cp-drawer-item-container {
  margin: 0px;
  padding: 0px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.cp-drawer-page-link {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: $paddingLeft;
}

.cp-drawer-page-link-item {
  font-weight: bold;
  margin-bottom: 10px;

  &.router-link-active {
    border-bottom: 2px solid $primary;
  }
}

.cp-drawer-contract {
  padding-left: $paddingLeft;
  padding-top: 10px;
  padding-bottom: 10px;
  color: white;
}

.cp-drawer-telephone {
  margin-right: 8px;
  color: white;
}

.cp-drawer-icon {
  margin-right: 5px;
  color: white;
  cursor: pointer;
}
</style>
